import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd"; // Using Ant Design Input for better UI consistency
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";
const Education = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "educationalQualificationList",
  });

  const experienceDetails = watch("educationalQualificationList") || [];

  const addExperienceRow = () => {
    const newExperience = {
      qualificationID: 0,
      companyCode: watch("companyCode"),
      employeeCode: watch("employeeCode"),
      degreeName: "",
      fieldOfStudy: "",
      institutionName: "",
      startDate: "",
      endDate: "",
      grade: "",
      country: "",
      documentImage: "",
      remarks: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("educationalQualificationList", [
      ...experienceDetails,
      newExperience,
    ]);
  };

  const removeExperience = (index) => {
    const updatedExperience = experienceDetails.filter((_, i) => i !== index);
    setValue("educationalQualificationList", updatedExperience);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addExperienceRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Degree Name</th>
              <th>Field Of Study</th>
              <th>Institution Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Grade</th>
              <th>Country</th>
              <th>Document Image</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {experienceDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].degreeName`}
                      type="text"
                      placeholder="Degree Name"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]
                          ?.degreeName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].fieldOfStudy`}
                      type="text"
                      placeholder="Field Of Study"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]
                          ?.fieldOfStudy
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].institutionName`}
                      type="text"
                      placeholder="Institution Name"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]
                          ?.institutionName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].startDate`}
                      type="date"
                      placeholder="Start Date"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]?.startDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(
                            `educationalQualificationList[${index}].startDate`
                          ),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].endDate`}
                      type="date"
                      placeholder="End Date"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]?.endDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(
                            `educationalQualificationList[${index}].endDate`
                          ),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].grade`}
                      type="text"
                      placeholder="Grade"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]?.grade
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].country`}
                      type="text"
                      placeholder="Country"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]?.country
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `educationalQualificationList[${index}].documentImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(
                          `educationalQualificationList[${index}].documentImage`,
                          value
                        )
                      }
                    />
                  </td>
                  <td>
                    <Input
                      name={`educationalQualificationList[${index}].remarks`}
                      type="text"
                      placeholder="Remarks"
                      className={`form-control ${
                        errors?.educationalQualificationList?.[index]?.remarks
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Education;
